















import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Playlist } from '@/classes/playlist'
import { getPlaylistsFlattenedRecursive } from '@/helpers/library'
import { Track } from '@/classes/track'
import { LibraryMixin, HistoryViewMixin } from '@/mixins'

@Component({
  components: {
    PlaylistSelector: require('@/components/PlaylistSelector').default
  }
})
export default class Playlists extends Mixins(LibraryMixin, HistoryViewMixin) {
  @Prop({
    default: 'Continue'
  })
  confirmLabel: string

  selectedPlaylists: Playlist[] = []

  get disabled(): boolean {
    return this.selectedPlaylists.reduce((acc, val) => {
      return acc + val.tracks.length
    }, 0) === 0
  }

  async next() {
    const flat = getPlaylistsFlattenedRecursive(this.selectedPlaylists)

    const selectedTracks: Track[] = []

    for (const pl of flat) {
      for (const trackId of pl.tracks) {
        const track = this.library.tracksObject[trackId]

        if (track) {
          selectedTracks.push(track as Track)
        }
      }
    }

    this.$emit('confirm', selectedTracks)
  }
}
